export default function Base() {
  this.String = () => JSON.stringify();
}
